import { useMemo, useState } from "react";
import { Copy, Check } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const snippet = (opts) => `<!-- itzkatu embed — paste anywhere in your Shopify template (page.liquid, section, or custom section) -->
<div id="itzkatu-embed" data-view="${opts.view}" data-limit="${opts.limit}"></div>
<link rel="preconnect" href="https://fonts.googleapis.com">
<link href="https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:wght@600;800&family=IBM+Plex+Mono:wght@400;500&family=Manrope:wght@400;600&display=swap" rel="stylesheet">
<style>
  #itzkatu-embed{--ink:#111;--bone:#FFFFFF;--blood:#5D3FD3;background:var(--bone);color:var(--ink);border:1px solid var(--ink);font-family:'Manrope',sans-serif;padding:24px}
  #itzkatu-embed .k-h{font-family:'Bricolage Grotesque',sans-serif;font-weight:800;text-transform:uppercase;letter-spacing:-0.02em;font-size:32px;line-height:1;margin:0 0 24px}
  #itzkatu-embed .k-list{list-style:none;padding:0;margin:0;border-top:1px solid var(--ink)}
  #itzkatu-embed .k-row{display:grid;grid-template-columns:120px 1fr auto;gap:12px;align-items:center;border-bottom:1px solid var(--ink);padding:14px 0;font-family:'IBM Plex Mono',monospace;font-size:11px;text-transform:uppercase;letter-spacing:0.18em}
  #itzkatu-embed .k-title{font-family:'Bricolage Grotesque',sans-serif;font-weight:700;font-size:18px;letter-spacing:-0.01em;text-transform:uppercase}
  #itzkatu-embed .k-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(180px,1fr));gap:16px}
  #itzkatu-embed .k-card{border:1px solid var(--ink);text-decoration:none;color:var(--ink);display:block;transition:transform .3s ease}
  #itzkatu-embed .k-card:hover{transform:translateY(-4px)}
  #itzkatu-embed .k-card img{width:100%;aspect-ratio:4/5;object-fit:cover;display:block;filter:grayscale(1) contrast(1.1)}
  #itzkatu-embed .k-card:hover img{filter:none}
  #itzkatu-embed .k-meta{padding:10px;border-top:1px solid var(--ink);font-family:'IBM Plex Mono',monospace;font-size:10px;text-transform:uppercase;letter-spacing:0.2em}
  #itzkatu-embed .k-cta{background:var(--ink);color:var(--bone);padding:8px 12px;font-family:'IBM Plex Mono',monospace;font-size:10px;text-transform:uppercase;letter-spacing:0.2em;text-decoration:none}
  #itzkatu-embed .k-cta:hover{background:var(--blood);color:var(--ink)}
</style>
<script>
(function(){
  var host = document.getElementById('itzkatu-embed');
  var view = host.dataset.view || 'artists';
  var limit = parseInt(host.dataset.limit || '6', 10);
  var API = '${BACKEND_URL}/api';
  function esc(s){return String(s||'').replace(/[&<>"']/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
  function render(){
    fetch(API + '/' + view).then(function(r){return r.json();}).then(function(items){
      items = (items||[]).slice(0, limit);
      var html = '<h3 class="k-h">itzkatu — ' + view + '</h3>';
      if(view === 'events'){
        html += '<ul class="k-list">' + items.map(function(e){
          var d = new Date(e.date);
          var day = d.toLocaleDateString('en-GB',{day:'2-digit',month:'short',year:'numeric'}).toUpperCase();
          return '<li class="k-row"><span>'+esc(day)+'</span><span class="k-title">'+esc(e.title)+'</span>'+(e.ticket_url? '<a class="k-cta" href="'+esc(e.ticket_url)+'" target="_blank" rel="noreferrer">tickets →</a>':'<span>sold out</span>')+'</li>';
        }).join('') + '</ul>';
      } else {
        html += '<div class="k-grid">' + items.map(function(a){
          return '<a class="k-card" href="https://itzkatu.com/artists/'+esc(a.slug||'')+'" target="_blank" rel="noreferrer">'+(a.image_url? '<img src="'+esc(a.image_url)+'" alt="'+esc(a.name)+'">':'')+'<div class="k-meta"><div class="k-title">'+esc(a.name)+'</div>'+esc(a.discipline||'')+'</div></a>';
        }).join('') + '</div>';
      }
      host.innerHTML = html;
    }).catch(function(){ host.innerHTML = '<p>itzkatu: unable to load.</p>'; });
  }
  render();
})();
</script>
<!-- /itzkatu embed -->`;

export default function ShopifyEmbed() {
    const [view, setView] = useState("artists");
    const [limit, setLimit] = useState(6);
    const [copied, setCopied] = useState(false);
    const code = useMemo(() => snippet({ view, limit }), [view, limit]);

    const copy = async () => {
        try {
            await navigator.clipboard.writeText(code);
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
        } catch {}
    };

    return (
        <div data-testid="embed-page" className="px-4 md:px-8 py-6 md:py-8">
            <div className="grid grid-cols-12 gap-6 mb-10">
                <div className="col-span-12 md:col-span-8">
                    <div className="font-mono text-xs uppercase tracking-[0.3em] text-[#555]">shopify embed</div>
                    <h1 className="mt-4 font-heading font-black text-5xl md:text-7xl uppercase tracking-tighter leading-[0.9]">
                        drop it in.
                    </h1>
                    <p className="mt-6 font-body text-base md:text-lg text-[#333] max-w-2xl">
                        paste the snippet in any shopify page or section. it fetches live artists or events from the itzkatu
                        api and renders them in the label's aesthetic — no framework required.
                    </p>
                </div>
            </div>

            <div className="grid grid-cols-12 gap-6">
                <div className="col-span-12 md:col-span-4">
                    <div className="border border-[#333] p-6">
                        <div className="font-mono text-xs uppercase tracking-[0.3em] text-[#555]">config</div>

                        <label className="block font-mono text-[10px] uppercase tracking-[0.2em] mt-6 mb-2">view</label>
                        <div className="flex gap-2">
                            {["artists", "events"].map((v) => (
                                <button
                                    key={v}
                                    data-testid={`embed-view-${v}`}
                                    onClick={() => setView(v)}
                                    className={`font-mono text-[10px] uppercase tracking-[0.2em] px-4 py-2 border border-[#333] transition-colors ${
                                        view === v ? "bg-[#333] text-[#FFFFFF]" : "hover:bg-[#333] hover:text-[#FFFFFF]"
                                    }`}
                                >
                                    {v}
                                </button>
                            ))}
                        </div>

                        <label className="block font-mono text-[10px] uppercase tracking-[0.2em] mt-6 mb-2">limit</label>
                        <input
                            type="number"
                            min={1}
                            max={20}
                            value={limit}
                            onChange={(e) => setLimit(parseInt(e.target.value || "1", 10))}
                            data-testid="embed-limit"
                            className="w-full bg-transparent focus:border-[#5D3FD3] outline-none font-mono text-sm py-2"
                        />

                        <button
                            onClick={copy}
                            data-testid="embed-copy"
                            className="mt-8 w-full inline-flex items-center justify-center gap-2 bg-[#333] text-[#FFFFFF] hover:bg-[#5D3FD3] hover:text-[#333] transition-colors px-4 py-3 font-mono text-xs uppercase tracking-[0.2em]"
                        >
                            {copied ? (
                                <>
                                    <Check size={14} /> copied
                                </>
                            ) : (
                                <>
                                    <Copy size={14} /> copy snippet
                                </>
                            )}
                        </button>

                        <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.2em] text-[#555]">
                            works in shopify pages, custom sections, or any liquid template.
                        </p>
                    </div>
                </div>

                <div className="col-span-12 md:col-span-8">
                    <div className="border border-[#333] bg-[#333] text-[#FFFFFF] p-4 md:p-6 overflow-x-auto">
                        <pre className="font-mono text-[11px] leading-relaxed whitespace-pre-wrap break-all">{code}</pre>
                    </div>
                </div>
            </div>
        </div>
    );
}
